import { useLayoutEffect } from 'react';
import { insertElementsToHTMLBanner } from './insertElementsToHTMLBanner';
export function useHTMLBannerInserts(_ref) {
  var eventEmitter = _ref.eventEmitter,
    bundleParams = _ref.bundleParams,
    containerId = _ref.containerId,
    bundleName = _ref.bundleName;
  useLayoutEffect(function () {
    var removeElementsFromHTMLBanner = null;
    var unsubscribe = null;
    if (containerId && bundleParams && bundleName) {
      switch (bundleName) {
        case 'banner.html':
        case 'banner.interscroller':
          {
            unsubscribe = eventEmitter.subscribe(function (data) {
              var _unsubscribe;
              /**
               * @description Тут событие load не сработает, так как мы подписываемся уже когда баннер загружен.
               * То есть мы проверяем на наличие bundleParams, то это поле приходит по событию load
               */
              switch (data.event) {
                case 'render':
                  removeElementsFromHTMLBanner = insertElementsToHTMLBanner(bundleParams, containerId);
                  (_unsubscribe = unsubscribe) === null || _unsubscribe === void 0 ? void 0 : _unsubscribe();
                  break;
              }
            });
            break;
          }
      }
    }
    return function () {
      var _removeElementsFromHT, _unsubscribe2;
      (_removeElementsFromHT = removeElementsFromHTMLBanner) === null || _removeElementsFromHT === void 0 ? void 0 : _removeElementsFromHT();
      (_unsubscribe2 = unsubscribe) === null || _unsubscribe2 === void 0 ? void 0 : _unsubscribe2();
    };
  }, [bundleName, bundleParams, containerId, eventEmitter]);
}